module.exports = __webpack_public_path__ + "static/media/dtFpImage.7ecc7ec9.png";